import fetch from "isomorphic-fetch";
import { useHistory } from "react-router-dom";
import { API } from "../config";
import { getCookie, userSessionExpired } from "./auth";

const Jobs = () => {
    const history = useHistory();

    const addJob = (job) => {
        return fetch(`${API}/add-job`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(job),
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const getJobs = () => {
        return fetch(`${API}/get-jobs`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const getUserJobs = (email) => {
        const query = email ? `?email=${encodeURIComponent(email)}` : "";
        return fetch(`${API}/get-user-jobs${query}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const deleteJob = (Id) => {
        return fetch(`${API}/delete-job/${Id}`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const deleteCompanyJob = (Id, email) => {
        const query = email ? `?email=${encodeURIComponent(email)}` : "";
        return fetch(`${API}/company-delete-job/${Id}${query}`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const updateJob = (job, Id) => {
        return fetch(`${API}/update-job/${Id}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(job),
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const updateCompanyJob = (job, Id) => {
        return fetch(`${API}/company-update-job/${Id}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(job),
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const adminApproveJob = (Id) => {
        return fetch(`${API}/admin-approve-job/${Id}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const getApprovedCompanyJobs = (companyId) => {
        return fetch(`${API}/get-approved-company-jobs/${companyId}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const userAddJob = (job, companyId) => {
        return fetch(`${API}/user-add-job/${companyId}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(job),
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const applyForJob = (jobId, applicant) => {
        return fetch(`${API}/apply-job/${jobId}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(applicant),
        })
            .then((response) => response.json())
            .catch((err) => err);
    };

    const getJobApplicants = (jobId) => {
        return fetch(`${API}/job-applicants/${jobId}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const getJobApplicantDetails = (applicantId) => {
        return fetch(`${API}/job-applicant/${applicantId}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const updateJobApplicantStatus = (applicantId, payload) => {
        return fetch(`${API}/job-applicant/${applicantId}/status`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const sendJobApplicantEmail = (applicantId, payload) => {
        return fetch(`${API}/job-applicant/${applicantId}/send-email`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    const archiveJobApplicant = (applicantId) => {
        return fetch(`${API}/job-applicant/${applicantId}/archive`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
            },
        })
            .then((response) => {
                userSessionExpired(response, history);
                return response.json();
            })
            .catch((err) => err);
    };

    return {
        addJob,
        userAddJob,
        applyForJob,
        getJobs,
        getUserJobs,
        getJobApplicants,
        getJobApplicantDetails,
        updateJobApplicantStatus,
        sendJobApplicantEmail,
        archiveJobApplicant,
        deleteJob,
        deleteCompanyJob,
        updateJob,
        updateCompanyJob,
        adminApproveJob,
        getApprovedCompanyJobs,
    };
};

export default Jobs;
